module.exports = __webpack_public_path__ + "90f5e0b77816e4df6aafdaa379d88392.png";


/*****************
 ** WEBPACK FOOTER
 ** ./~/file-loader!../data/green_fish.png
 ** module id = 20
 ** module chunks = 0
 **/